<template>
    <div>
        <h1 style="text-align:center;margin-top:unset;">Facebook Live Status Connection</h1>
        <el-row>
            <el-col :span="12" style="padding-right: 10px;">
                <el-card>
                    <h2 style="text-align:center;margin-top:unset;">ข้อมูลร้านค้า</h2>
                    <el-row>
                        <el-col :span="12">
                            <el-input
                                v-model="searchText"
                                placeholder="ค้นหา"
                                @keypress.enter.native="onSearchShop()"
                                ></el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="primary" @click="onSearchShop()">ค้นหา</el-button>
                        </el-col>
                        <el-col style="padding-top: 20px;">
                            <div>
                                <el-row>
                                    <el-col :span="24">
                                        <el-table
                                            v-loading="loadingTableShop"
                                            :data="shopData"
                                            :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                                        >
                                            <el-table-column
                                                label="ชื่อร้าน"
                                                prop="name"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                label="รหัสร้านค้า"
                                                prop="shopId"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                label="อีเมลล์ร้าน"
                                                prop="email"
                                            >
                                            </el-table-column>
                                            <el-table-column fixed="right" label="จัดการ" width="80">
                                                <template slot-scope="scope">
                                                    <el-button :key="scope.$index" size="small" icon="el-icon-edit" type="primary" plain @click="showPageDetail(scope.row)"></el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                        <el-col :span="24" style="padding-top: 20px;">
                            <el-pagination
                                @size-change="changeLimitPage"
                                @current-change="changeCurrentPage"
                                :current-page.sync="pagination.currentPage"
                                :page-sizes="pagination.pageSizes"
                                :page-size="10"
                                layout="prev, pager, next, sizes"
                                :total="pagination.allPage * pagination.limit">
                            ></el-pagination>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
            <!-- Page Detail -->
            <el-col :span="12" style="padding-left: 10px;">
                <el-card>
                    <h2 style="text-align:center;margin-top:unset;">ข้อมูลเพจ</h2>
                    <el-row>
                        <el-col style="padding-top: 20px;">
                            <div>
                                <el-row>
                                    <el-col :span="24">
                                        <el-table
                                            :data="pageData"
                                            :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                                            class="page-table"
                                        >
                                            <el-table-column
                                                label="ชื่อร้าน"
                                            >
                                            <template slot-scope="scope">
                                                <div>
                                                    {{ scope.$index === 0 ? shopNameInPageDetail : '' }}
                                                </div>
                                            </template>
                                            </el-table-column>
                                            <el-table-column
                                                label="ชื่อเพจ"
                                                prop="pageName"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                label="รหัสเพจ"
                                                prop="pageId"
                                            >
                                            </el-table-column>
                                        </el-table>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import axios from 'axios'
import fgApi from '@/services/fillgoods'

export default {
    name: 'FacebookLiveConnection',
    data () {
        return {
            searchText: '',
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            loadingTableShop: false,
            loadingTablePage: false,
            timeoutSearch: null,
            cancelTokenSearchShop: null,
            shopData: [],
            pageData: [],
            shopNameInPageDetail: ''
        }
    },
    created () {
        this.onFetchListShop()
    },
    methods: {
        changeLimitPage (val) {
            this.pagination.limit = val
            this.onFetchListShop()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.onFetchListShop()
        },
        onSearchShop (val) {
            this.pagination.currentPage = 1
            this.pagination.offset = 0
            this.onFetchListShop()
        },
        async onFetchListShop (name = null) {
            clearTimeout(this.timeoutSearch)
            this.timeoutSearch = setTimeout(async () => {
                try {
                    if (this.cancelTokenSearchShop) {
                        this.cancelTokenSearchShop.cancel()
                    }
                    this.cancelTokenSearchShop = axios.CancelToken.source()
                    this.loadingTableShop = true
                    const param = {
                        targetUserId: name,
                        search: this.searchText,
                        limit: this.pagination.limit,
                        offset: this.pagination.offset,
                        isApprove: true
                    }
                    let resShop = await fgApi.shop.searchListShop(param, this.cancelTokenSearchShop.token)
                    this.shopData = []
                    this.shopData = resShop.data
                    this.pagination.allPage = resShop.allPage
                    this.loadingTableShop = false
                } catch (error) {
                    if (axios.isCancel(error)) { return }
                    console.error(error)
                }
            }, 500)
        },
        async showPageDetail (shopObj) {
            try {
                this.loadingTablePage = true
                const param = {
                    shopId: shopObj.shopId
                }
                let resPage = await fgApi.fbLiveConnect.searchPageInshop(param)
                this.pageData = []
                this.pageData = resPage.data
                this.shopNameInPageDetail = shopObj.name
                this.loadingTablePage = false
            } catch (error) {
                console.error(error)
            }
        }
    }
}
</script>

<style lang="scss">
    .page-table > .el-table th, .el-table td {
            vertical-align: top;
    }
</style>
